import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import Footer from "../../../Components/Footer/footer";

const FarmerPartnerView = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getFarmerDetails();
  }, []);

  const getFarmerDetails = async () => {
    try {
      const res = await performRequest(
        "GET",
        `/pmg/farmer-partner/get-farmer-partner-by-id/${id}`
      );

      if (res.status === 200) {
        setData(res.data);
      } else {
        Toast("error", "Failed to fetch details");
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          {/* HEADER */}
          <div className="page-header d-print-none mb-3">
            <div className="row align-items-center">
              <div className="col">
                <h2 className="page-title fw-bold">Farmer Partner Profile</h2>
              </div>
            </div>
          </div>

          {data ? (
            <div className="row g-4 ">
              {/* LEFT PROFILE CARD */}
              <div className="col-md-4 ">
                <div className="card shadow-sm border-0 text-center p-4 h-100 bg-primary-subtle">
                  <img
                    src={
                      data?.profileImage ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHe5JZvnW6uJe9-Ae2dUy6qJpBUjSOqdT46w&s"
                    }
                    alt="profile"
                    className="rounded-circle mx-auto mb-3"
                    style={{
                      width: "110px",
                      height: "110px",
                      objectFit: "cover",
                      border: "3px solid #f1f1f1",
                    }}
                  />

                  <h4 className="fw-semibold mb-1">{data.farmPartnerName}</h4>
                  <p className="text-muted small mb-3">
                    {data.storeName || "No Store Name"}
                  </p>

                  <div className="d-flex justify-content-center gap-2">
                    <span
                      className={`badge px-3 py-2 ${
                        data.isActive
                          ? "bg-success text-white"
                          : "bg-danger text-white"
                      }`}
                    >
                      {data.isActive ? "Active" : "Inactive"}
                    </span>

                    <span
                      className={`badge px-3 py-2 ${
                        data.isAvailable
                          ? "bg-primar text-white"
                          : "bg-secondary text-white"
                      }`}
                    >
                      {data.isAvailable ? "Available" : "Unavailable"}
                    </span>
                  </div>
                </div>
              </div>

              {/* RIGHT DETAILS */}
              <div className="col-md-8">
                <div className="d-flex flex-column gap-3">
                  {/* CONTACT INFO */}
                  <div className="card shadow-sm border-0 p-3">
                    <h5 className="fw-semibold mb-3 border-bottom pb-2">
                      Contact Information
                    </h5>

                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Email</small>
                        <div className="fw-medium">{data.email}</div>
                      </div>

                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Contact</small>
                        <div className="fw-medium">{data.contactNumber}</div>
                      </div>

                      <div className="col-md-6">
                        <small className="text-muted">Alternate Contact</small>
                        <div className="fw-medium">
                          {data.alternateContactNumber || "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ADDRESS */}
                  <div className="card shadow-sm border-0 p-3">
                    <h5 className="fw-semibold mb-3 border-bottom pb-2">
                      Address
                    </h5>

                    <div className="text-muted">
                      <div>{data.addressLine1 || "-"}</div>
                      <div>{data.addressLine2 || "-"}</div>
                      <div className="mt-1">
                        {data.city}, {data.state} - {data.pincode}
                      </div>
                    </div>
                  </div>

                  {/* SERVICE DETAILS */}
                  <div className="card shadow-sm border-0 p-3">
                    <h5 className="fw-semibold mb-3 border-bottom pb-2">
                      Service Details
                    </h5>

                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Service Area</small>
                        <div className="fw-medium">
                          {data.serviceAreaName || "-"}
                        </div>
                      </div>

                      <div className="col-md-6 mb-2">
                        <small className="text-muted">Radius</small>
                        <div className="fw-medium">
                          {data.serviceRadiusKm || 0} KM
                        </div>
                      </div>

                      <div className="col-md-12">
                        <small className="text-muted">Working Hours</small>
                        <div className="fw-medium">
                          {data.openingTime || "--"} -{" "}
                          {data.closingTime || "--"}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* LOCATION */}
                  <div className="card shadow-sm border-0 p-3">
                    <h5 className="fw-semibold mb-3 border-bottom pb-2">
                      Location
                    </h5>

                    <div className="row">
                      <div className="col-md-6">
                        <small className="text-muted">Latitude</small>
                        <div className="fw-medium">{data.latitude || 0}</div>
                      </div>

                      <div className="col-md-6">
                        <small className="text-muted">Longitude</small>
                        <div className="fw-medium">{data.longitude || 0}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-5">
              <h5 className="text-muted">Loading...</h5>
            </div>
          )}

          <div className="footer text-end">
            <button
              className="btn btn-outline-secondary"
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
            <button
              className="btn btn-primary ms-4"
              onClick={() => navigate(`/farmer-partners/edit/${data?.id}`)}
            >
              Edit Profile
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FarmerPartnerView;
